import { Text, VStack } from '@chakra-ui/react';
import { ReviewStars } from '@time-line/components/common';
import { VerifiedBuyerBadge } from 'components/reviews/VerifiedBuyerBadge';
import type { JunipProductReview } from 'types/reviews/JunipProductReview';

import { Container } from './Container';

const VISIBLE_LINES = 6;
const WIDTH_BASE = 220;
const WIDTH_MD = 293;

interface ReviewProps {
  review: JunipProductReview;
  height: number;
}

export const Review = ({ review, height }: ReviewProps) => {
  const { rating, title, customer, verifiedBuyer } = review;

  return (
    <Container
      insetBorder={false}
      width={{ base: WIDTH_BASE, md: WIDTH_MD }}
      height={height}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={{ base: '2xs', md: 'sm' }}
      gap={{ base: '5xs', sm: '4xs' }}
      color="gray.600"
    >
      {rating && <ReviewStars score={rating} />}
      {title && (
        <Text
          as="h3"
          size="h3-serif"
          textAlign="center"
          hanging-punctuation="first last"
          noOfLines={VISIBLE_LINES}
          textOverflow="ellipsis"
          paddingY="4xs"
          _before={{
            content: '"\u201c"',
          }}
          _after={{
            content: '"\u201d"',
          }}
        >
          {title}
        </Text>
      )}
      <VStack gap={0}>
        {customer && (
          <Text size="overline">
            {customer.firstName} {customer.lastName}
          </Text>
        )}
        {verifiedBuyer && <VerifiedBuyerBadge size="overline" />}
      </VStack>
    </Container>
  );
};
